import { coreService } from 'network-utils';

export enum LearningPathNodeType {
    LESSON = 'lesson',
    CHALLENGE = 'challenge',
    COURSE = 'course',
    ASSESSMENT = 'assessment',
    MIXED = 'mixed'
}

export interface LearningPathNodeProps {
    id: number;
    uuid: string;
    name: string;
    durationMinutes: number;
    potentialScore: number;
    score: number;
    badge: {
        type: string;
        achieved: boolean;
    };
    status: coreService.ProgressStatus | null;
    progressPercentage: number;
    children: number[];
    parents: number[];
    nextUrl: string;
    type: LearningPathNodeType;
    itemTypesCount: { [key in coreService.LearningPathContentType]: number };
    numberOfItems: number;
    isMandatory?: boolean;
    isRoot?: boolean;
}

export interface LearningPathData {
    uuid: string;
    name: string;
    description: string;
    level: coreService.LearningPathLevel;
    durationMinutes: number;
    potentialScore: number;
    status: coreService.ProgressStatus | null;
    completedAt: string | null;
    nodes: LearningPathNodeProps[];
    lastSelectedNodeId: number | null;
    score: number;
    languages: string[];
    progress?: number;
    badge?: string;
}

export interface LearningPathProps extends LearningPathData {
    profilePicture: string;
    nickname: string;
    onSelectNode: Function;
    tenant: string;
}
